// App.js

import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import { AppConfigProvider } from './context/AppConfigContext';
import PageNotFound from './components/Error/PageNotFound';

import { authRoutes } from './routes/AuthRoutes';
import { userRoutes } from './routes/UserRoutes';
import { companyRoutes } from './routes/CompanyRoutes';
import { accountRoutes } from './routes/AccountRoutes';
import { frontendRoutes } from './routes/FrontendRoutes';
import { userStatRoutes } from './routes/UserStatRoutes';

import { FlashMessageProvider } from './context/FlashContext';
import {accountDetailsRoute} from './routes/AccountDetailsRoute';
import {accountsRoute} from './routes/AccountsRoute';
import { saleAccountsRoute } from './routes/SalesAccountsRoute';
import {businessSegmentsRoute} from './routes/BusinessSegmentsRoutes';
import {growthOpportunitiesRoute} from './routes/GrowthOpportunitiesRoutes';
import {nudgesRoutes} from './routes/NudgesRoutes';
import {technologyLandscapeRoutes} from './routes/TechnologyLandscapeRoutes';
// import {documentsRoutes} from './routes/DocumentsRoutes';
import {questionsRoutes} from './routes/QuestionsRoutes';
import {onBoardingRoutes} from './routes/OnBoardingRoutes';
import {userProfileRoutes} from './routes/UserProfileRoutes';
import { verifyTokenRoutes } from './routes/VerifyTokenRoutes';
import { documentsRoutes } from './routes/Documents';
import {chatRoute} from './routes/ChatRoute';
import {JobPostingsRoutes} from './routes/JobPostingsRoutes';
import React, { useEffect } from 'react';
import { Provider } from "react-redux";
import store from './store/store';
import AgreementCheck from './components/Frontend/Agreements/userJoinAgreement';
import { agentsRoutes } from './routes/Agents';
import { demoRequestsRoutes } from './routes/DemoRequestsRoutes';
import { TaskStatusProvider } from './context/TaskStatusContext';
import { BannerProvider } from './context/BannerContext';
import { GroupTaskWebSocketProvider } from './context/GroupTaskWebSocketContext';
import { meetingPrepsRoutes } from './routes/MeetingPrepsRoutes';
import { autoNurtureRoutes } from './routes/AutoNurtureRoutes';
import {manageAccountsRoute} from './routes/ManageAccountsRoute';
import { emailFeedbackRoute } from './routes/emailFeedbackRoute';
import { AuthorizedUserProvider } from './context/AuthorizedUserContext';
import { globalContactsRoutes } from './routes/globalContactsRoutes';
import { globalAccountsRoutes } from './routes/globalAccountsRoutes';
import OfflineBanner from './components/Frontend/genericComponents/uiElements/OfflineBanner';
import { chatRouteV2 } from './routes/ChatRouteV2';

function App() {

  useEffect(() => {
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:6450759,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }, []);

  return (
    <AppConfigProvider>
      <OfflineBanner/>
      <BannerProvider>
      <Provider store={store}>
        <UserProvider>
          <AuthorizedUserProvider>
           <GroupTaskWebSocketProvider>
          <TaskStatusProvider>
          <FlashMessageProvider>
            <Router>
              <Routes>
                {emailFeedbackRoute}
                {verifyTokenRoutes}
                {authRoutes}
                {userRoutes}
                {/* Protected Routes */}
                <Route element={<AgreementCheck />}>
                  {companyRoutes}
                  {accountRoutes}
                  {frontendRoutes}
                  {/* {dashboardRoutes} */}
                  {accountDetailsRoute}
                  {accountsRoute}
                  {saleAccountsRoute}
                  {businessSegmentsRoute}
                  {onBoardingRoutes}
                  {userProfileRoutes}
                  {growthOpportunitiesRoute}
                  {nudgesRoutes}
                  {questionsRoutes}
                  {userStatRoutes}
                  {technologyLandscapeRoutes}
                  {documentsRoutes}
                  {chatRouteV2}
                  {JobPostingsRoutes}
                  {agentsRoutes}
                  {demoRequestsRoutes}
                  {meetingPrepsRoutes}
                  {autoNurtureRoutes}
                  {globalContactsRoutes}
                  {globalAccountsRoutes}
                  {manageAccountsRoute}
                </Route>
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </Router>
          </FlashMessageProvider>
          </TaskStatusProvider>
          </GroupTaskWebSocketProvider>
          </AuthorizedUserProvider>
        </UserProvider>
      </Provider>
      </BannerProvider>
    </AppConfigProvider>
  );
}

export default App;